module.exports = __webpack_public_path__ + "img/中國標準_03.4a7604b6.png";